import React from "react";
import { SDLCMetadataConstants, SDLCMetadataTypeGuards } from "@sscs/types";
import { Menu, Select } from "@sscs/ui";
import { UNDECLARED_LICENSE } from "../../constants";
const LicenseFamilyFilter = ({ id, value, onChange, className, displayUndeclared = true, ...props }) => {
    var _a;
    return (React.createElement(Select, { label: "Filter by license family", id: id, labelId: `${id}-label`, displayEmpty: true, shrinkLabel: true, value: value === "" ? UNDECLARED_LICENSE : (value !== null && value !== void 0 ? value : "ALL"), onChange: (value) => {
            if (SDLCMetadataTypeGuards.stringIsLicenseFamily(value) ||
                value === UNDECLARED_LICENSE) {
                onChange(value);
            }
            else {
                onChange(null);
            }
        }, className: className, "data-filtered-by-link": (_a = props["data-filtered-by-link"]) !== null && _a !== void 0 ? _a : false },
        React.createElement(Menu.Item, { id: "show-all-licenses", value: "ALL" }, "Show all license families"),
        displayUndeclared && (React.createElement(Menu.Item, { id: "filter-by-undeclared", value: UNDECLARED_LICENSE }, UNDECLARED_LICENSE)),
        SDLCMetadataConstants.licenseFamily
            .filter((license) => license !== "")
            .map((licenseFamily) => (React.createElement(Menu.Item, { key: licenseFamily, id: `filter-by-${licenseFamily}`, value: licenseFamily }, licenseFamily)))));
};
export default LicenseFamilyFilter;
//# sourceMappingURL=LicenseFamilyFilter.js.map